<template>
  <modal @close_modal="close_modal"
         :title="$t('set_label_sets.edit_title')"
         :loading="loading"
  >
    <template v-slot:content>
      <v-text-field id="name"
                          v-model="label_set_name" :label="$t('set_label_sets.edit_name')"></v-text-field>
      <v-text-field id="description"
                          v-model="label_set_description" :label="$t('set_label_sets.edit_description')"></v-text-field>
      <label-list v-if="loading===false"
              @select_label_ids="select_label_ids"
              :selected_labels_ids="selected_label_ids"
              :show_select="true"></label-list>
    </template>
    <template v-slot:buttons>
      <v-btn
          color="primary"
          text
          id="cancel_button"
          @click="cancel"
      >
        {{$t('set_label_sets.btn_cancel')}}
      </v-btn>

      <v-btn
          color="primary"
          text
          id="save_button"
          @click="save"
      >
        {{$t('set_label_sets.btn_save')}}
        <v-icon
            dark
            primary
            right
        >
          fas fa-level-down-alt fa-rotate-90
        </v-icon>
      </v-btn>
    </template>

  </modal>
</template>

<script>
import Modal from "@/components/Modal";
import LabelList from "@/components/manage_labels/LabelList";
export default {
  props: {
    label_set: {required: true},
  },
  data() {
    return {
      selected_label_ids: [],
      loading: true,
      label_set_name: null, 
      label_set_description: null 
    }
  },
  methods: {
    close_modal() {
      this.$emit('close_modal')
    },
    cancel () {
      this.$emit('close_modal')
    },
    select_label_ids(label_ids) {
      this.selected_label_ids = label_ids;
    },
    async loadSelectedLabelIds() {
      try {
        const idsResponse = await this.$api.label_set.getLabelIds(this.label_set);
        this.selected_label_ids = idsResponse.label_ids || [];
      } catch (error) {
        console.error('Failed to load label set labels', error);
        try {
          const labels = await this.$api.label_set.getLabels(this.label_set);
          this.selected_label_ids = (labels || []).map((label) => label.id);
        } catch (fallbackError) {
          const relations = this.label_set?.relationships?.label_set_labels;
          this.selected_label_ids = relations
            ? relations.map((entry) => entry.label_id)
            : [];
        }
      }
    },
    async save() {
      this.loading = true; 
      let local_label_set = null;   
      if (!this.label_set) {
        local_label_set = await this.$api.label_set.addLabelSet(this.label_set_name, this.label_set_description);
      }
      else {
        local_label_set = await this.$api.label_set.patchLabelSet(this.label_set, this.label_set_name, this.label_set_description);
      }
      await this.$api.label_set.updateLabels(local_label_set, this.selected_label_ids);
      this.$emit('reload')
      this.$emit('close_modal')
      this.loading = false; 
    },
  },
  computed: {
  },
  async mounted() {
    if (this.label_set) {
      this.label_set_name = this.label_set.name;
      this.label_set_description = this.label_set.description;
      await this.loadSelectedLabelIds();
    } else {
      this.selected_label_ids = [];
      this.label_set_name = 'new';
      this.label_set_description = 'new';
    }
    this.loading = false;
  },

  name: "EditLabelSet",
  components: { LabelList, Modal},
}
</script>

<style scoped>

</style>